import { AddressFormFieldNames } from 'shared/enums/addressFormFieldNames';
import { createFormConfig, ValidationRules } from 'helpers/createFormConfig';
import { GestionnaireFormValues } from './GestionnaireFormValues';
import { gestionnaireValidationRules } from './gestionnaireValidationRules';

const gestionnaireFormConfig = createFormConfig<GestionnaireFormValues>(
  gestionnaireValidationRules as ValidationRules<keyof GestionnaireFormValues>,
  {
    [AddressFormFieldNames.Country]: 'FR',
  }
);

export { gestionnaireFormConfig };
